import { createContext, useContext } from 'react';

export const NewRoleContext = createContext();

export const useNewRoleContext = () => useContext(NewRoleContext);
